import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';
import { UserSimpleInfo } from 'src/types';

type DashboardGetUserResponse = {
  user: UserSimpleInfo;
};

export const useDashboardGetUser = () => {
  const { data, isLoading, error, fetcher } = useFetcher<DashboardGetUserResponse | null>(null);

  const fetchUser = useCallback(
    (userId: string) => {
      fetcher(EndPoints.getDashboardUser.replace(':id', userId), {
        requiredToken: true,
        method: 'GET',
      });
    },
    [fetcher],
  );

  return {
    user: data?.user ?? null,
    isLoading,
    error,
    fetchUser,
  };
};
